export default class ElementService {
  constructor() {
  }

  toggleVisibleStateOfAllElementsInArray(elementArray, show) {
    if (show) {
      elementArray.forEach(element => {
        if (element) {
          element.classList.add('active');
          element.classList.remove('hidden');
        }
      });
    } else {
      elementArray.forEach(element => {
        if (element) {
          element.classList.remove('active');
          element.classList.add('hidden');
        }
      });
    }
  }

  toggleVisibleStateOfElement(element, show) {
    if (element) {
      if (show) {
        element.classList.add('active');
        element.classList.remove('hidden');
      }
      else {
        element.classList.remove('active');
        element.classList.add('hidden');
      }
    }
  }

  getChildElementsByClass(parentElements, childElementClass) {
    const elements = [];
    if (parentElements) {
      parentElements.forEach(parentEl => {
        elements.push(parentEl.querySelector(childElementClass));
      });
    }
    return elements;
  }
}
